import { createEvent, sample } from "effector";
function createQueryController({
  operation,
  name
}) {
  const start = createEvent({ name: `${name}.start` });
  const refresh = createEvent({ name: `${name}.refresh` });
  sample({
    clock: refresh,
    fn: (variables) => ({ variables, meta: { force: false } }),
    target: operation.__.execute
  });
  sample({
    clock: start,
    fn: (variables) => ({ variables, meta: { force: true } }),
    target: operation.__.execute
  });
  return { start, refresh };
}
export {
  createQueryController
};
//# sourceMappingURL=controller.mjs.map
